<template>
  <div
    class="row pt-1"
    v-if="berechtigungen.m_finanzen.read"
  >
    <div class="col-lg-12">
      <div class="tile-categorie-frame">
        <div class="tile-categorie">
          <div class="header">
            <span>{{ $t('global.finance') }}</span>
          </div>
          <div class="body">
            <div class="row">
              <div :class="kachelCol">
                <div
                  class="tile-frame"
                  :class="[kachelStyle, (!berechtigungen.b_finanzen_honorar.read && !berechtigungen.m_debitoren.read && !berechtigungen.m_mahnungen.read && !berechtigungen.m_zahlungseingaenge.read && !berechtigungen.m_belege.read) ? 'h-2' : 'h-1']"
                >
                  <router-link :to="{ name: 'auftraege' }">
                    <div class="tile bg-mint inverted">
                      <div class="icon-container fa-container">
                        <font-awesome-icon
                          icon="fa-duotone fa-file-invoice-dollar"
                          transform="shrink-4"
                        />
                      </div>
                      <div class="title">
                        {{ $t('global.orders') }}
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
              <div
                :class="kachelCol"
                v-if="berechtigungen.b_finanzen_honorar.read"
              >
                <div
                  class="tile-frame h-1"
                  :class="kachelStyle"
                >
                  <router-link :to="{ name: 'honorar-liste' }">
                    <div class="tile bg-mint inverted">
                      <div class="icon-container fa-container">
                        <font-awesome-icon
                          icon="fa-duotone fa-user-clock"
                          transform="left-1 shrink-4"
                        />
                      </div>
                      <div class="title">{{ $t('global.fees') }}</div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
            <div class="row">
              <div
                :class="kachelKleinCol"
                v-if="berechtigungen.m_debitoren.read"
              >
                <div
                  class="tile-frame h-1"
                  :class="kachelKleinStyle"
                >
                  <router-link :to="{ name: 'Debitoren' }">
                    <div class="tile bg-light-mint inverted">
                      <div class="icon-container fa-container">
                        <font-awesome-icon
                          icon="fa-duotone fa-money-bill"
                          transform="left-1 shrink-4"
                        />
                      </div>
                      <div class="title">
                        {{ $t('global.debtors') }}
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
              <div
                :class="kachelKleinCol"
                v-if="berechtigungen.m_mahnungen.read"
              >
                <div
                  class="tile-frame h-1"
                  :class="kachelKleinStyle"
                >
                  <router-link :to="{ name: 'mahnungen' }">
                    <div class="tile bg-light-mint inverted">
                      <div class="icon-container fa-container">
                        <font-awesome-icon
                          icon="fa-duotone fa-shield-exclamation"
                          transform="shrink-4"
                        />
                      </div>
                      <div class="title">
                        {{ $t('global.reminders') }}
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
              <div
                :class="kachelKleinCol"
                v-if="berechtigungen.m_zahlungseingaenge.read"
              >
                <div
                  class="tile-frame h-1"
                  :class="kachelKleinStyle"
                >
                  <router-link :to="{ name: 'Zahlungen' }">
                    <div class="tile bg-light-mint inverted">
                      <div class="icon-container fa-container">
                        <font-awesome-icon
                          icon="fa-duotone fa-wallet"
                          transform="shrink-4"
                        />
                      </div>
                      <div class="title">
                        {{ $t('global.dashboard_payments') }}
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>

              <div
                :class="kachelKleinCol"
                v-if="berechtigungen.m_belege.read"
              >
                <div
                  class="tile-frame h-1"
                  :class="kachelKleinStyle"
                >
                  <router-link :to="{ name: 'Belege' }">
                    <div class="tile bg-light-mint inverted">
                      <div class="icon-container fa-container">
                        <font-awesome-icon
                          icon="fa-duotone fa-receipt"
                          transform="shrink-4"
                        />
                      </div>
                      <div class="title">
                        {{ $t('global.receipts') }}
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  //import { defineComponent } from '@vue/composition-api'

  export default {
    name: 'StartseiteFinanzen',
    components: {},
    mixins: [],
    props: {
      kachelStyle: { type: String },
      kachelCol: { type: String },
      kachelKleinStyle: { type: String },
      kachelKleinCol: { type: String },
    },
    data() {
      return {}
    },
    created() {},
    mounted() {},
    computed: {},
    methods: {},
  }
</script>
